window.formatters = {
    alphaNumeric : function(string){
        return ('' + string).replace(/[^0-9a-z]/gi, '');
    },
    digits : function(string){
        return ('' + string).replace(/\D/g, '');
    },
    allCaps : function(string){
        return _.toUpper(string);

    },
    name : function(string){
        return _.upperFirst(string);
    },
    phone : function(string){
        let digits = this.digits(string);
        digits = _.trimStart(digits, '1');
        let digits_length = digits.length;
        if(digits_length > 10){
            return '(' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6, 10);
        }
        if(digits_length > 6){
            return '(' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6);
        }
        if(digits_length > 3){
            return '(' + digits.substring(0, 3) + ') ' + digits.substring(3);
        }
        if(digits_length > 0){
            return '(' + digits;
        }
        return digits;
    },
    dollars : function(string){
        let cleaned = string.replace(/[^0-9.]/g, '');
        let amount = Number(cleaned);
        if(amount > 0){
            return '$' + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return '';
    },
    vin : function(string){
        return this.allCaps(this.alphaNumeric(string));
    }
}



// WEBPACK FOOTER //
// ./resources/js/formatters.js